import axios, { Method } from '@/apps/open/utils/axios'

const isPrivate = process.env.VUE_APP_IS_PRIVATE
const serverPath = isPrivate ? '/plussvr' : 'https://plussvr.wps.cn'

/**
 * 获取WPS+企业列表
 */
export const getCompanyList = (params: any) => axios({ url: `${serverPath}/compose/v1/u/user-companies`, method: Method.Get, params })

/**
 * 获取私网配置
 */
export const getPrivateConfig = () => axios({ url: `/drive/wps-private-entry.json`, method: Method.Get })
